module.exports = __webpack_public_path__ + "img/workspace-onboarding/install-loom-ios-8086586e0ca1fbd3ed52e8c8ffce2954.png";